// src/components/PrivacyPolicy.js
import React from 'react';

function TermsConditions() {
    return (
        <div className="p-8">
        <h2 className="text-3xl font-bold mb-6">Términos y Condiciones de Registro</h2>
        <div className="space-y-4 text-gray-700">
            <p>
                Al registrarte en Kifli Courier, aceptas los siguientes términos y condiciones. Te pedimos que los leas con atención antes de crear tu cuenta.
            </p>
            <h3 className="text-xl font-bold pt-4">1. Aceptación del Usuario</h3>
            <p>
                Al crear una cuenta en KifliCourier.com, declaras que la información ingresada es verídica, actual y verificable. Te comprometes a actualizar tus datos cuando sea necesario y a utilizar la plataforma de manera responsable.
            </p>
            <h3 className="text-xl font-bold pt-4">2. Uso de la Cuenta</h3>
            <p>
                •	Tu cuenta es personal e intransferible.
            </p>
            <p>
                •	Eres responsable por mantener la confidencialidad de tu usuario y contraseña.
            </p>
            <p>
                •	Toda actividad realizada desde tu cuenta se considerará efectuada por ti.
            </p>
            <h3 className="text-xl font-bold pt-4">3. Veracidad de la información</h3>
            <p>
                El usuario se compromete a proporcionar datos correctos como nombre, identificación, correo, número telefónico y dirección de entrega.
            </p>
            <p>
                Kifli Courier no se hace responsable por retrasos o inconvenientes causados por datos incorrectos o incompletos.
            </p>
            <h3 className="text-xl font-bold pt-4">4. Servicios Ofrecidos</h3>
            <p>
                Al registrarte, podrás acceder a servicios como:
            </p>
            <p>
                •	Alertar paquetes para su transporte.
            </p>
            <p>
                •	Préstamo de tarjeta o préstamo de cuenta Prime, cuando corresponda.
            </p>
            <p>
                •	Compra asistida, si el usuario así lo solicita.
            </p>
            <p>
                •	Seguimiento de paquetes conforme el servicio lo permita.
            </p>
            <p>
                Kifli Courier no proporciona casilleros físicos ni direcciones personalizadas para compras. El usuario debe coordinar previamente el envío de cualquier paquete según las indicaciones del equipo de Kifli Courier.
            </p>
            <h3 className="text-xl font-bold pt-4">5. Responsabilidad del usuario sobre sus compras</h3>
            <p>
                El usuario es responsable de:
            </p>
            <p>
                •	Verificar compatibilidad, peso, medidas y características del producto que desea comprar.
            </p>
            <p>
                •	Revisar políticas de garantía y devoluciones del vendedor.
            </p>
            <p>
                •	Confirmar que el producto no esté prohibido o restringido para importar.
            </p>
            <p>
                Cuando el usuario solicita Préstamo de Tarjeta o un servicio similar, Kifli Courier actúa únicamente como intermediario de compra. No asumimos responsabilidad por defectos, fallas, diferencias o daños del producto.
            </p>
            <h3 className="text-xl font-bold pt-4">6. Tarifas y pagos</h3>
            <p>
                •	Los precios de transporte, compra asistida y servicios adicionales serán informados previamente.
            </p>
            <p>
                •	Las tarifas pueden actualizarse y se aplicarán las vigentes en la fecha de facturación.
            </p>
            <p>
                •	Todo pago debe realizarse antes de la entrega del paquete.
            </p>
            <h3 className="text-xl font-bold pt-4">7. Manejo y seguridad de paquetes</h3>
            <p>
                Kifli Courier procurará manejar cada paquete con cuidado. Sin embargo:
            </p>
            <p>
                •	No nos responsabilizamos por daños causados por el vendedor, por el transporte hacia Ecuador o por embalajes inapropiados.
            </p>
            <p>
                •	No somos responsables por paquetes que nunca fueron entregados a Kifli Courier.
            </p>
            <p>
                Una vez que el paquete sea oficialmente recibido por nuestro equipo, se aplican los protocolos internos de seguridad y manejo.
            </p>
            <h3 className="text-xl font-bold pt-4">8. Productos prohibidos o restringidos</h3>
            <p>
                El usuario acepta no enviar productos prohibidos o restringidos por leyes de EE.UU. o del Ecuador.
            </p>
            <p>
                Kifli Courier puede rechazar o retener temporalmente cualquier artículo que incumpla la normativa.
            </p>
            <h3 className="text-xl font-bold pt-4">9. Uso de la plataforma</h3>
            <p>
                Al registrarte aceptas:
            </p>
            <p>
                •	Que utilizaremos tu información únicamente para fines operativos y de comunicación.
            </p>
            <p>
                •	Que podrás recibir notificaciones y actualizaciones del estado de tus servicios.
            </p>
            <p>
                •	Que el sistema muestra información basada en los datos que recibe el equipo logístico de Kifli Courier.
            </p>
            <h3 className="text-xl font-bold pt-4">10. Modificaciones</h3>
            <p>
                Kifli Courier puede modificar estos términos en cualquier momento. Los cambios serán publicados en esta página y se considerarán aceptados al continuar usando la plataforma.
            </p>
            <h3 className="text-xl font-bold pt-4">11. Aceptación final</h3>
            <p>
                Al registrarte confirmas que has leído, entendido y aceptado estos Términos y Condiciones.
            </p>
        </div>  
        </div>
    );
}

export default TermsConditions;